import * as angular from 'angular';
import { NfcRetailerStickersService } from '../../nfc-retailer-stickers.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { DeleteStickerRequest } from '../../../core';

class AddDeletedSticker implements ng.IController {
    static $inject = ['$scope', '$translate', '$timeout', 'nfcRetailerStickersService', 'notificationService'];
    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    stickerNumber: string;
    waiting: boolean;
    form: ng.IFormController & { stickerID: ng.INgModelController};


    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $timeout: ng.ITimeoutService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService
    ) { }

    $onInit = () => {
       this.stickerNumber = '';
    }

    close = () => {
        this.modalInstance.close({ $value: 'close' });
    }

    delete = () => {
        var modelIsValid = this.validateStickerNumberFormat(this.stickerNumber);
        if (!modelIsValid) {
            let stickerIDModel = this.form.stickerID;
            stickerIDModel.$setValidity('stickerID', modelIsValid);
            this.$timeout(() => stickerIDModel.$setValidity('stickerID', true), 2000);
            return;
        }
        let request = { StickerNumber: this.stickerNumber } as DeleteStickerRequest;
        this.waiting = true;
        return this.nfcRetailerStickersService.deleteSticker(request)
            .then((response) => {
                this.modalInstance.close({ $value: 'ok'});
            })
            .catch(error => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    private validateStickerNumberFormat(modelValue: string): boolean {
        let pattern = /[A-Z]{1}\d{12}$/;
        return pattern.test(modelValue);
	}

}

angular.module('naut').component('addDeletedSticker', {
    template: require('./add-deleted-sticker.component.html'),
    controller: AddDeletedSticker,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/deleted-tab/add-sticker/add-deleted-sticker.component.ts